import { SKYSCANNER_JHA } from '@web-platform/shared-universal-constants/src/jhaHeader';
import { getJhaToken } from '@web-platform/shared-universal-utils-frontend/src/helpers/getJhaToken/getJhaToken';
import { waitForNewRelicAgentScript } from '@web-platform/shared-universal-utils-frontend/src/helpers/waitForNewRelicAgentScript';
import { GLOBAL, redirect } from 'saddlebag-browser';

let contextPromiseCache: Promise<string> | null = null;

export const contextPromise = (): Promise<string> => {
  if (contextPromiseCache) {
    return contextPromiseCache;
  }

  contextPromiseCache = new Promise((resolve, reject) => {
    const $window = GLOBAL.getWindow();
    const path = `path=${$window.location.pathname}`;
    const query = $window.location.search ? `${$window.location.search}&${path}` : `?${path}`;

    const fetchContext = (retries: number) => {
      const xhr = new XMLHttpRequest();
      const url = `/g/banana/api/context${query}`;

      xhr.open('GET', url);

      const eventHandler = (event: Event) => {
        if (event.type === 'load') {
          if (xhr.status === 200) {
            resolve(xhr.responseText);
          }

          // As in src/shared/data-access-frontend/network/internals/clients/http.ts handleBotTraffic will provide a URL to redirect to. We don't want to retry the request here.
          if (xhr.status === 403) {
            try {
              const response = JSON.parse(xhr.responseText);

              if (response.redirect_to) {
                waitForNewRelicAgentScript(() => redirect(response.redirect_to));
              }
            } catch {
              const message = `Failed to parse 403 response body; responseText: ${xhr.responseText}; url: ${url}`;
              reject(new Error(message));
            }
          } else if (xhr.status >= 400) {
            const message = `XHR Error Type: ${event.type}; status: ${xhr.status}; responseText: ${xhr.responseText}; readyState: ${xhr.readyState}; url: ${url}`;
            reject(new Error(message));
          }
        } else if (retries) {
          fetchContext(retries - 1);
        } else {
          const message = `XHR Error Type: ${event.type}; status: ${xhr.status}; responseText: ${xhr.responseText}; readyState: ${xhr.readyState}; responseHeaders: ${xhr.getAllResponseHeaders()}; url: ${url}`;

          reject(new Error(message));
        }
      };

      xhr.onload = eventHandler;
      xhr.onabort = eventHandler;
      xhr.onerror = eventHandler;
      xhr.ontimeout = eventHandler;

      const jhaToken = getJhaToken();
      if (jhaToken) {
        xhr.setRequestHeader(SKYSCANNER_JHA, jhaToken);
      }

      xhr.send();
    };

    fetchContext(2);
  });
  return contextPromiseCache;
};
